import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=259b478d&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259b478d')) {
      api.createRecord('259b478d', component.options)
    } else {
      api.reload('259b478d', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=259b478d&", function () {
      api.rerender('259b478d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z5TIyS6XHmfv/JS/comp/openstreetmap.vue"
export default component.exports